module.exports = __webpack_public_path__ + "static/media/kitIcon.0438e9f2.png";